/**
 * Formats date to a 'dd Mon YYYY' format
 * @param dateString
 */
export const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  const month = date.toLocaleDateString('en-us', { month: 'short' });

  return `${date.getDate()} ${month} ${date.getFullYear()}`;
};

/**
 * Formats date to a 'dd-Mon-YYYY' format
 * @param dateString
 */
export const formatDateWithDashes = (dateString: Date) => {
  const date = new Date(dateString);

  const day = date.toLocaleString('default', { day: '2-digit' });
  const month = date.toLocaleString('default', { month: 'short' });
  const year = date.toLocaleString('default', { year: 'numeric' });

  return day + '-' + month + '-' + year;
};

/**
 * Formats epoch date format to a 'dd-Mon-YYYY' format
 * @param epochDate
 */
export const formatEpochDate = (epochDate: number) => {
  const date = new Date(epochDate);

  const day = date.toLocaleString('default', { day: '2-digit' });
  const month = date.toLocaleString('default', { month: 'short' });
  const year = date.toLocaleString('default', { year: 'numeric' });

  return day + '-' + month + '-' + year;
};

/**
 * Formats date format to a 'YYYY-MM-DD' format
 * @param dateString
 */
export const formatDatePayload = (dateString: Date): string => {
  const date = new Date(dateString);
  const day = date.toLocaleDateString('en-us', { day: '2-digit' });
  const month = date.toLocaleDateString('en-us', { month: '2-digit' });

  return `${date.getFullYear()}-${month}-${day}`;
};

/**
 * format date & time with respect to `timezone`
 *
 * @param date any string which can be parse by Date constructor
 * @param timezone
 * @returns an arry of [ formated_date_string, formated_time_string ];
 */
export const formatDateTime = (date: string, timezone?: string) => {
  const d = new Date(date);
  const _date = d.toLocaleDateString('en-US', {
    timeZone: timezone,
    month: 'long',
    day: '2-digit',
    year: 'numeric'
  });
  const _time = d.toLocaleTimeString('en-US', {
    timeZone: timezone,
    hour: '2-digit',
    minute: '2-digit'
  });

  return [_date, _time] as const;
};
